import { message, notification } from "antd";
import React, { useState, useEffect } from "react";
import { Form, Button, Col, Card, Dropdown } from "react-bootstrap";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import axiosInstance from "../../utils/api";

const Sensor1 = () => {
    
  //fetch api http://api.cl-ds.com/adminGetNodeSelection/
  const [data, setData] = useState({
    prefix: [],
    serial: [],
    filteredSerial: [],
    sensor: [],
  });

  const [values, setvalues] = useState({
    sensor: [],
    sensor_set: [],
  });

  const { control, handleSubmit, watch, setValue } = useForm({
    defaultValues: {
      sensor: values.sensor,
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "sensor",
  });

  const getApi = () => {
    axiosInstance.get("https://api.cl-ds.com/adminGetSpecificSensor/" + values.serial)
      .then((fetchdata) => {
        console.log(fetchdata.data);
        // setvalues(prevData => ({
        //   ...prevData,
        //   prefix: fetchdata.prefix,
        //   serial: fetchdata.serial,
        //   sensor: fetchdata.sensor
        // }))
        setValue("sensor", fetchdata.data.sensor);
      });
  };

  // useEffect(() => {
  //   fetch('https://api.cl-ds.com/adminGetSpecificSensor/AM0001/', {
  //     headers: {
  //       "Authorization": "Token 4ef76b7b1288bbda537123e0fd51a446bd0b0a2f"
  //     }
  //   })
  //     .then(res => res.json())
  //     .then(fetchdata => {
  //       console.log(fetchdata)
  //       // setvalues(prevData => ({
  //       //   ...prevData,
  //       //   prefix: fetchdata.prefix,
  //       //   serial: fetchdata.serial,
  //       //   sensor: fetchdata.sensor
  //       // }))
  //       setValue("sensor",fetchdata.sensor)
  //     });
  // }, []);

  //gets data for "Serial Prefix, and Serial"
  useEffect(() => {
    axiosInstance.get("https://api.cl-ds.com/adminGetNodeList/")
      .then((fetchdata) => {
        console.log(fetchdata);
        setData((prevData) => ({
          ...prevData,
          prefix: fetchdata.data.prefix,
          serial: fetchdata.data.serial,
          sensor: fetchdata.data.sensor,
        }));
      });
  }, []);

  //gets data for "add"
  useEffect(() => {
    axiosInstance.get("https://api.cl-ds.com/adminGetSensorSelection/")
      .then((fetchdata) => {
        setData((prevData) => ({
          ...prevData,
          category: !!fetchdata?.data.category.length ? fetchdata.data.category : [],
          parameter: !!fetchdata?.data.parameter.length ? fetchdata.data.parameter : [],
          visualization: !!fetchdata?.data.visualization.length
            ? fetchdata.data.visualization
            : [],
          summary_chart: !!fetchdata?.data.summary_chart.length
            ? fetchdata.data.summary_chart
            : [],
        }));
        console.log(fetchdata.data);
      });
  }, []);

  //View Data
  const handleOnSubmit = async (formdata) => {
    const sensordata = formdata.sensor.map((item) => {
      return {
        ...item,
        prefix: values.prefix,
        serial: values.serial,
        sensor_set: values.sensor_set,
      };
    });

    const formData = {
      ...values,
      sensor: sensordata,
    };

    localStorage.setItem("formdata", JSON.stringify(formData));

    notification.open({
      message: "Form Data",
      duration: 0,
      description: JSON.stringify(formData),
      onClick: () => {
        console.log("Button was clicked");
      },
    });
    console.log(formData);
  };

  const handleChange = (e) => {
    const fileReader = new FileReader();
    fileReader.readAsText(e.target.files[0], "UTF-8");
    fileReader.onload = (e) => {
      console.log("e.target.result", e.target.result);
      const { sensor, prefix, ...filedata } = JSON.parse(e.target.result);
      console.log(filedata);
      prefixOnChange(prefix);
      setvalues({
        ...filedata,
      });
      setValue("sensor", sensor);
      console.log(values);
    };
  };

  const handleClick = (formdata) => {
    const formData = {
      serial: values.serial,
      sensor_set: values.sensor_set,
      sensor: formdata.sensor,
    };
    console.log(values);
    console.log(formData);

    localStorage.setItem("formdata", JSON.stringify(formData));

    //sends to post api
    const SendOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token 4ef76b7b1288bbda537123e0fd51a446bd0b0a2f",
      },
      body: JSON.stringify(formData),
    };
    //Display message
    axiosInstance.get("https://testing.cloudatik.com/adminRegisterSensorV3/", JSON.stringify(formData))
      .then((data) => {
        console.log(data.data.message);
        message.success(data.data.message);
      });
  };

  const onChangehandler = (e) => {
    setvalues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  //on prefix change
  const prefixOnChange = (e) => {
    setvalues({
      ...values,
      prefix: e,
    });
    const filtered = data.serial.filter((item) => item.substring(0, 2) === e);
    setData((prevData) => ({
      ...prevData,
      filteredSerial: filtered,
    }));
    setvalues({
      ...values,
      serial: filtered[0] || "",
    });
  };

  const exportJsonFile = () => {
    let dataStr = localStorage.getItem("formdata");
    let dataUri =
      "data:dataInput/json;charset=utf-8," + encodeURIComponent(dataStr);

    let exportFileDefaultName = "sensorconfig.json";

    let linkElement = document.createElement("a");
    linkElement.setAttribute("href", dataUri);
    linkElement.setAttribute("download", exportFileDefaultName);
    linkElement.click();
    console.log("File has been sent to download");
  };

  return (
    <div className="col-lg-8 mx-auto">
      <Form onSubmit={handleSubmit(handleClick)}>
        <h2 className="text-center pb-3"> Dashboard/Sensor </h2>

		<div className="col-12 mb-3">
			<Form.Control
			className="ml-3 mb-3"
			type="file"
			onChange={handleChange}
			></Form.Control>
			<Button
			variant="outline-primary"
			style={{ float: "right" }}
			type="primary"
			onClick={handleSubmit(handleOnSubmit)}
			>
			View Data
			</Button>
		</div>

		<div className="col-12 mb-3">
			<Form.Group>
				<Form.Label>Serial Prefix</Form.Label>
				<select
					className="form-control"
					as="select"
					name="prefix"
					value={values.prefix}
					onChange={(e) => prefixOnChange(e.target.value)}
					custom
				>
					<option value="none" selected>
					Select an Option
					</option>
					{!!data?.prefix?.length &&
					data.prefix.map((item) => (
						<option key={item} value={item}>
						{item}
						</option>
					))}
				</select>
			</Form.Group>
		</div>

		<div className="col-12 mb-3">
			<Form.Group>
			<Form.Label>Serial</Form.Label>
				<select
					className="form-control"
					as="select"
					name="serial"
					value={values.serial}
					onChange={(e) => onChangehandler(e)}
					custom>
					<option value="none" selected>
					Select an Option
					</option>
					{!!data.filteredSerial?.length &&
					data.filteredSerial.map((item) => (
						<option key={item} value={item}>
						{item}
						</option>
					))}
				</select>
			</Form.Group>
		</div>

		<div className="col-12 mb-3">
			<Form.Group>
				<Form.Label>Sensor_Set</Form.Label>
				<Form.Control
					type="number"
					name="sensor_set"
					value={values.sensor_set}
					placeholder="sensor_set"
					onChange={(e) => onChangehandler(e)}
				></Form.Control>
			</Form.Group>
		</div>

        <ul>
          {fields.map((item, index) => (
            <li style={{ listStyle: "none" }} key={item.id}>
              <Card>
                <Card.Header>Sensor {index + 1}</Card.Header>
                <Card.Body>
                  <Dropdown
                    name={`sensor.${index}.category`}
                    control={control}
                    defaultValue={item.category}
                    label="category"
                    placeholder="category"
                    options={data?.category}
                  />
                  <Controller
                    name={`sensor.${index}.category`}
                    control={control}
                    defaultValue={item.category}
                    render={({ field }) => (
                      <>
                        <Form.Group as={Col}>
                          <Form.Label>category</Form.Label>
                          <Form.Control
                            as="select"
                            placeholder="category"
                            required
                            custom
                            {...field}
                          >
                            <option value="none" selected>
                              Select an Option
                            </option>
                            {!!data?.category?.length &&
                              data.category.map((item) => (
                                <option key={item} value={item}>
                                  {item}
                                </option>
                              ))}
                          </Form.Control>
                        </Form.Group>
                      </>
                    )}
                  />
                  <Controller
                    name={`sensor.${index}.parameter`}
                    control={control}
                    defaultValue={item.parameter}
                    render={({ field }) => (
                      <>
                        <Form.Group as={Col}>
                          <Form.Label>Parameter</Form.Label>
                          <Form.Control
                            as="select"
                            placeholder="parameter"
                            required
                            custom
                            {...field}
                          >
                            <option value="none" selected>
                              Select an Option
                            </option>
                            {!!data?.parameter?.length &&
                              data.parameter.map((item) => (
                                <option key={item} value={item}>
                                  {item}
                                </option>
                              ))}
                          </Form.Control>
                        </Form.Group>
                      </>
                    )}
                  />
                  <Controller
                    name={`sensor.${index}.visualization`}
                    control={control}
                    defaultValue={item.visualization}
                    render={({ field }) => (
                      <>
                        <Form.Group as={Col}>
                          <Form.Label>Visualization</Form.Label>
                          <Form.Control
                            as="select"
                            placeholder="Visualization"
                            required
                            custom
                            {...field}
                          >
                            <option value="none" selected>
                              Select an Option
                            </option>
                            {!!data?.visualization?.length &&
                              data.visualization.map((item) => (
                                <option key={item} value={item}>
                                  {item}
                                </option>
                              ))}
                          </Form.Control>
                        </Form.Group>
                      </>
                    )}
                  />

                  <Controller
                    name={`sensor.${index}.summary_chart`}
                    control={control}
                    defaultValue={item.summary_chart}
                    render={({ field }) => (
                      <>
                        <Form.Group as={Col}>
                          <Form.Label>Summary_chart</Form.Label>
                          <Form.Control
                            as="select"
                            placeholder="Summary_chart"
                            required
                            custom
                            {...field}
                          >
                            <option value="none" selected disabled hidden>
                              Select an Option
                            </option>
                            {!!data?.summary_chart?.length &&
                              data.summary_chart.map((item) => (
                                <option key={item} value={item}>
                                  {item}
                                </option>
                              ))}
                          </Form.Control>
                        </Form.Group>
                      </>
                    )}
                  />

                  <Controller
                    name={`sensor.${index}.alarm_enabled`}
                    control={control}
                    defaultCheck={item.alarm_enabled}
                    render={({ field: { value, ...field } }) => (
                      <>
                        <Form.Group>
                          <Form.Check
                            label="Alarm Enable"
                            inline
                            checked={value}
                            type="checkbox"
                            placeholder="Alarm Enable"
                            {...field}
                          />
                        </Form.Group>
                      </>
                    )}
                  />

                  <Controller
                    name={`sensor.${index}.slider_enabled`}
                    control={control}
                    defaultCheck={item.slider_enabled}
                    render={({ field: { value, ...field } }) => (
                      <>
                        <Form.Group>
                          <Form.Check
                            label="Slider Enable"
                            inline
                            checked={value}
                            type="checkbox"
                            placeholder="Slider Enable"
                            {...field}
                          />
                        </Form.Group>
                      </>
                    )}
                  />

                  <Controller
                    name={`sensor.${index}.visual_enabled`}
                    control={control}
                    defaultCheck={item.visual_enabled}
                    render={({ field: { value, ...field } }) => (
                      <>
                        <Form.Group>
                          <Form.Check
                            label="Visual Enable"
                            inline
                            checked={value}
                            type="checkbox"
                            placeholder="Visual Enable"
                            {...field}
                          />
                        </Form.Group>
                      </>
                    )}
                  />

                  <Controller
                    name={`sensor.${index}.chart_enabled`}
                    control={control}
                    defaultCheck={item.chart_enable}
                    render={({ field: { value, ...field } }) => (
                      <>
                        <Form.Group>
                          <Form.Check
                            label="Chart Enable"
                            inline
                            checked={value}
                            type="checkbox"
                            placeholder="Chart Enable"
                            {...field}
                          />
                        </Form.Group>
                      </>
                    )}
                  />

                  <Controller
                    name={`sensor.${index}.modbus_factor`}
                    control={control}
                    defaultValue={item.modbus_factor}
                    render={({ field }) => (
                      <>
                        <Form.Group as={Col}>
                          <Form.Label>Modbusfactor</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Modbusfactor"
                            required
                            {...field}
                          ></Form.Control>
                        </Form.Group>
                      </>
                    )}
                  />

                  <Controller
                    name={`sensor.${index}.cal_coeff`}
                    control={control}
                    defaultValue={item.cal_coeff}
                    render={({ field }) => (
                      <>
                        <Form.Group as={Col}>
                          <Form.Label>Calcoeff</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Calcoeff"
                            required
                            {...field}
                          ></Form.Control>
                        </Form.Group>
                      </>
                    )}
                  />

                  <Controller
                    name={`sensor.${index}.cal_const`}
                    control={control}
                    defaultValue={item.cal_const}
                    render={({ field }) => (
                      <>
                        <Form.Group as={Col}>
                          <Form.Label>Calconst</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Calconst"
                            required
                            {...field}
                          ></Form.Control>
                        </Form.Group>
                      </>
                    )}
                  />

                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => {
                      console.log(index);
                      remove(index);
                    }}
                  >
                    Delete
                  </button>
                </Card.Body>
              </Card>
            </li>
          ))}
        </ul>

		<div style={{display:"flex", justifyContent:"space-between", marginBottom:"1rem"}}>
			<button
			type="button"
			className="btn btn-success"
			onClick={() =>
				append({
				category: "",
				parameter: "",
				visualization: "",
				alarm_enable: false,
				slider_enable: false,
				visual_enable: false,
				chart_enable: false,
				modbus_factor: "",
				cal_coeff: "",
				cal_const: "",
				})
			}
			>
			Add
			</button>

			<div>
				<Button onClick={getApi} style={{marginRight:"1rem"}}>
				Load Server
				</Button>
				<Button
				className="displaybutton"
				variant="outline-primary"
				type="file"
				onClick={exportJsonFile}
				>
				Download Config
				</Button>
			</div>

		</div>
		
		<div className="d-flex justify-content-center mb-5">
			<Button variant="outline-primary" type="submit">
				Submit
			</Button>
		</div>

      </Form>
    </div>
  );
}

export default Sensor1